export enum NotificationTypeEnum {
  HOME_NOTIFICATION = 'HOME_NOTIFICATION'
}
